<template>
  <section class="table-content">
    <el-row class="notify-head">
      <el-col :span="12">
        <div class="notify-title">
        <i class="el-icon-s-platform"></i>
        <span>诉求进展</span>
        </div>
      </el-col>
      <el-col :span="12" style="text-align: right;padding-right: 40px">
        <div class="opinion-collect">
          <el-link style="color: #0068BC" :underline="false" href="../../static/投诉意见办理情况满意度调查表.docx">满意度调查表下载</el-link>
        </div>
      </el-col>
    </el-row>
    <div :style="{'height':blockHeight+'px'}" style="overflow: auto">
      <el-row :gutter="5" class="appeal-item" v-for="item in tableData" :key="item.id">
      <el-col :span="3">
        <div class="appeal-mark">
          <el-tag type="info" v-if="item.status === 'wait'">待处理</el-tag>
          <el-tag v-if="item.status === 'distribution'">已分配</el-tag>
          <el-tag v-if="item.status === 'receive'">已接收</el-tag>
          <el-tag type="warning" v-if="item.status === 'unhandle'">不处理</el-tag>
          <el-tag type="success" v-if="item.status === 'finish'">已完成</el-tag>
          <el-tag type="danger" v-if="item.status === 'withdraw'">退&nbsp;&nbsp;&nbsp;&nbsp;回</el-tag>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="appeal-content" @click="handleDetail(item)">
          <div class="center-content">
            {{item.appealContent.substring(0,100)}}{{item.appealContent.length<100?'':'......'}}
          </div>
          <span style="color:#A30014;right: 8px;bottom: 6px;position: absolute">【详情】</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="appeal-tag">
          <el-button style="width: 110px" @click="handleWithdrawEdit(item.id)" size="mini" type="main" v-if="item.status === 'withdraw'||item.status === 'wait'">重新编辑</el-button>
          <el-button style="width: 110px" v-if="item.status === 'finish'" @click="uploadOpinion(item.id, item.opinionFile)" size="mini" type="main">上传调查表</el-button>
          <div class="appeal-time">申请时间:{{item.updateTime}}</div>
        </div>
      </el-col>
    </el-row>
    </div>
    <el-pagination
      class="table-page"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total">
    </el-pagination>
    <el-dialog title="详情" width="75%" :visible.sync="handleDetailInfoVisible" :close-on-click-modal="false">
      <el-form :model="handleDetailInfo" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input v-model="handleDetailInfo.enterpriseName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
              <el-input v-model="handleDetailInfo.enterpriseCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法定代表人：" prop="legalPerson">
              <el-input v-model="handleDetailInfo.legalPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系人：" prop="contactPerson">
              <el-input v-model="handleDetailInfo.contactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="contact">
              <el-input v-model="handleDetailInfo.contact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人身份证：" prop="contactIdCard">
              <el-input v-model="handleDetailInfo.contactIdCard" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业所在园区：" prop="parkName">
              <el-input v-model="handleDetailInfo.parkName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求类型：" prop="appealType">
              <el-select v-model="handleDetailInfo.appealType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in appealTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="诉求主要涉及单位：" prop="appealRelatedOrg">
              <el-input v-model="handleDetailInfo.appealRelatedOrg" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="诉求事项说明：" prop="appealContent">
              <el-input v-model="handleDetailInfo.appealContent" type="textarea" :rows="6" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="相关附件：">
              <div v-for="file in appealFile">
                <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="handleDetailInfo" style="border-top: 1px solid #888888;padding-top: 15px;" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="状态：" prop="status">
              <el-select v-model="handleDetailInfo.status" placeholder="" :disabled="true" style="width: 100%">
                <el-option
                  v-for="item in handleStatusDic"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理部门：">
              <el-input v-model="handleDetailInfo.handleOrganizationName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理时间：">
              <el-input v-model="handleDetailInfo.handleTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="处理意见：">
              <el-input v-model="handleDetailInfo.handleComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog title="详情" width="75%" :visible.sync="handlePayDetailInfoVisible" :close-on-click-modal="false">
      <el-form :model="handelPayDetailInfo" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input v-model="handelPayDetailInfo.enterpriseName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
              <el-input v-model="handelPayDetailInfo.enterpriseCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业所在园区：" prop="parkName">
              <el-input v-model="handelPayDetailInfo.parkName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业规模：" prop="enterpriseSize">
              <el-select v-model="handelPayDetailInfo.enterpriseSize" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in enterpriseSizeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业性质：" prop="enterpriseType">
              <el-select v-model="handelPayDetailInfo.enterpriseType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in enterpriseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业行业：" prop="enterpriseIndustry" :disabled="true">
              <el-select v-model="handelPayDetailInfo.enterpriseIndustry" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in enterpriseIndustryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目金额：" prop="amount">
              <el-input maxlength="50" v-model="handelPayDetailInfo.amount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="拖欠类型：" prop="appealType">
              <el-select v-model="handelPayDetailInfo.appealType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in appealPayTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业联系人：" prop="contactPerson">
              <el-input v-model="handelPayDetailInfo.contactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="contact">
              <el-input v-model="handelPayDetailInfo.contact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系邮箱：" prop="email">
              <el-input maxlength="150" v-model="handelPayDetailInfo.email" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求主要涉及单位：" prop="organizationNames">
              <el-input v-model="handelPayDetailInfo.organizationNames.toString()" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <span class="payInfoTag">被投诉方信息</span>
        <el-row :gutter="10" style="margin-top: 15px">
          <el-col :span="12">
            <el-form-item label="单位/企业名称：" prop="antiEnterpriseName">
              <el-input v-model="handelPayDetailInfo.antiEnterpriseName" maxlength="250" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="antiEnterpriseCode">
              <el-input v-model="handelPayDetailInfo.antiEnterpriseCode" maxlength="20" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="被投诉方所在地：" prop="antiAddress">
              <el-input v-model="handelPayDetailInfo.antiAddress" maxlength="200" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位/企业性质：" prop="antiEnterpriseType">
              <el-select v-model="handelPayDetailInfo.antiEnterpriseType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in antiEnterpriseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人：" prop="antiContactPerson">
              <el-input maxlength="50" v-model="handelPayDetailInfo.antiContactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="antiContact">
              <el-input maxlength="50" v-model="handelPayDetailInfo.antiContact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="诉求事项说明：" prop="appealContent">
              <el-input v-model="handelPayDetailInfo.appealContent" type="textarea" :rows="6" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="相关附件：">
              <div v-for="file in appealFile">
                <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="handelPayDetailInfo" style="border-top: 1px solid #888888;padding-top: 15px;" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="状态：" prop="status">
              <el-select v-model="handelPayDetailInfo.status" placeholder="" :disabled="true" style="width: 100%">
                <el-option
                  v-for="item in handleStatusDic"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理部门：">
              <el-input v-model="handelPayDetailInfo.handleOrganizationName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理时间：">
              <el-input v-model="handelPayDetailInfo.handleTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="处理意见：">
              <el-input v-model="handelPayDetailInfo.handleComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog title="上传满意度调查表" width="400px" :visible.sync="handleUploadAppealOpinionVisible" :close-on-click-modal="false">
      <el-upload
        class="upload-demo"
        drag
        action="/appeal/file/upload/appealOpinionDoc"
        :on-success="handleOpinionDocSuccess"
        :on-remove="handleOpinionDocRemove"
        :on-preview="handleOpinionDocPreview"
        :file-list="feedbackFileList"
        :on-exceed="masterFileMax"
        :limit="1">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </el-dialog>
  </section>
</template>
<script>
  import { portalEnterpriseAppealList, portalEnterpriseAppealFile, portalDictionary, portalAppealFeedback} from '@/api/restapi.js'
  export default {
    data () {
      return {
        blockHeight: (document.documentElement.clientHeight - 450),
        handleDetailInfoVisible: false,
        handlePayDetailInfoVisible: false,
        handleUploadAppealOpinionVisible: false,
        tableData: [],
        appealFile: [],
        feedbackFileList: [],
        appealTypeList: [],
        appealPayTypeList: [],
        enterpriseSizeList: [],
        enterpriseTypeList: [],
        enterpriseIndustryList: [],
        antiEnterpriseTypeList: [],
        opinionTypeList: [],
        payTypeList: [],
        uploadAppealOpinionId: '',
        handleDetailInfo: {
          organizationNames: ''
        },
        handelPayDetailInfo: {
          organizationNames: ''
        },
        handleStatusDic: [{
          code: 'unhandle',
          name: '不处理'
        },{
          code: 'finish',
          name: '已完成'
        },{
          code: 'wait',
          name: '待处理'
        },{
          code: 'distribution',
          name: '已分配'
        },{
          code: 'receive',
          name: '已接收'
        },{
          code: 'withdraw',
          name: '退回'
        }],
        loading: false,
        pageInfo: {
          page: 1,
          total: 0,
          size: 10
        }
      }
    },
    mounted () {
      portalDictionary('appeal_type').then(res => {
        if (res.data.code === 0) {
          this.opinionTypeList = res.data.data
        }
      })
      portalDictionary('appeal_pay_type').then(res => {
        if (res.data.code === 0) {
          this.appealPayTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_size').then(res => {
        if (res.data.code === 0) {
          this.enterpriseSizeList = res.data.data
        }
      })
      portalDictionary('enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.enterpriseTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_industry').then(res => {
        if (res.data.code === 0) {
          this.enterpriseIndustryList = res.data.data
        }
      })
      portalDictionary('anti_enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.antiEnterpriseTypeList = res.data.data
        }
      })
      this.searchList()
    },
    methods: {
      uploadOpinion (id,url) {
        this.uploadAppealOpinionId = id
        // console.log(this.feedbackFileList)
        this.feedbackFileList = []
        if (url) {
          this.feedbackFileList.push({
            name: '投诉意见办理情况满意度调查表.docx',
            response: {
              data: url
            }
          })
        }
        this.handleUploadAppealOpinionVisible = true
      },
      handleOpinionDocPreview (file) {
        console.log(file.response.data)
        window.open(file.response.data)
      },
      handleOpinionDocSuccess (res, file) {
        // console.log(file)
        // console.log(file.response.data)
        // this.feedbackFileList.push({
        //   fileName: file.name,
        //   fileUrl: file.response.data
        // })
        portalAppealFeedback(this.uploadAppealOpinionId,file.response.data).then(res => {
          if(res.data.code===0){
            this.$message({
              type: 'success',
              message: '上传成功'
            })
            this.searchList()
          }else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        }).catch(err => {

        })
      },
      masterFileMax (files, fileList) {
        this.$message({
          type: 'error',
          message: '最多仅能上传一个文件'
        })
      },
      handleOpinionDocRemove (res, file) {
        portalAppealFeedback(this.uploadAppealOpinionId,'').then(res => {
          if(res.data.code===0){
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.searchList()
          }else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        }).catch(err => {

        })
        // let att = []
        // file.forEach(f => {
        //   att.push({
        //     fileName: f.name,
        //     fileUrl: f.response.data
        //   })
        // })
        // this.feedbackFileList = att
      },
      searchList () {
        this.loading = true
        portalEnterpriseAppealList(this.pageInfo.page,this.pageInfo.size).then(res => {
          this.loading = false
          if(res.data.code===0){
            this.tableData = res.data.data.list
            this.pageInfo.total = res.data.data.total
          }else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        }).catch(err => {
          this.loading = false
        })
      },
      handleWithdrawEdit (id) {
        this.$router.push('/portal/appealInfo?id='+id)
      },
      handleDetail (row) {
        this.appealFile = []
        portalEnterpriseAppealFile(row.id).then(res => {
          if (res.data.code === 0) {
            this.appealFile = res.data.data
          }
        })
        if (row.infoType === 'opinion') {
          this.handleDetailInfo = Object.assign({}, row)
          this.appealTypeList = this.opinionTypeList
          this.handleDetailInfoVisible = true
        }else {
          this.handelPayDetailInfo = Object.assign({}, row)
          // this.appealTypeList = this.payTypeList
          this.handlePayDetailInfoVisible = true
        }
      },
      handleSizeChange (val) {
        this.pageInfo.size = val
        this.searchList()
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.searchList()
      }
    }
  }
</script>
<style>
  .notify-head {
    border-bottom: 1px #0068BC solid;
  }
  .notify-head .notify-title{
    background: #0068BC;
    width: 120px;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    color: #FFFFFF;
    font-size: 16px;
  }
  .appeal-mark {
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .appeal-mark span{
    font-size: 13px;
    font-weight: bold;
    border-radius: 20px;
    padding: 0px 20px;
  }
  .appeal-mark .mark-info-wait{
    border: 3px solid #0068BC;
    color: #0068BC;
  }
  .appeal-mark .mark-info-success{
    border: 3px solid #2FBB72;
    color: #2FBB72;
  }
  .appeal-mark .mark-info-warning{
    border: 3px solid #E99D74;
    color: #E99D74;
  }
  .appeal-mark .mark-info{
    font-size: 14px;
    font-weight: bold;
  }
  .appeal-item {
    border-bottom: 1px solid #dddddd;
    cursor: pointer;
  }
  .appeal-content {
    height: 60px;
    width: 100%;
    display: table;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 13px;
    position: relative;
  }
  .center-content {
    display: table-cell;
    vertical-align: middle;
  }
  .appeal-tag {
    padding-top: 5px;
    height: 50px;
    text-align: center;
    padding-right: 10px;
    position: relative;
  }
  .appeal-time {
    font-size: 10px;
    color: #ABABAB;
    position: absolute;
    bottom: 0px;
    left: 20px;
  }
  .table-content {
    background: #ffffff;
    width: 100%;
    padding: 10px 10px 15px;
  }
  .table-content .table-page {
    margin-top: 10px;
    text-align: right;
  }
  .opinion-collect {
    cursor: pointer;
    color: #0068BC;
    height: 40px;
    line-height: 40px;
  }
  .payInfoTag {
    color: #0068BC;
    border: 1px solid #0068BC;
    font-size: 15px;
    margin-left: 50px;
    border-radius: 5px;
    background: #f4fbfe;
    padding: 3px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/AppealProgress.vue